import { render } from "./PurchaseReportPage.vue?vue&type=template&id=d0b4671e&scoped=true&ts=true"
import script from "./PurchaseReportPage.vue?vue&type=script&lang=ts"
export * from "./PurchaseReportPage.vue?vue&type=script&lang=ts"

import "./PurchaseReportPage.vue?vue&type=style&index=0&id=d0b4671e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b4671e"]])

export default __exports__